import React from 'react'
import styled from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'
import { formatMoney } from '../Cart/utils'
import { Promotion, PromotionDiscountType } from 'shop/types/common'
import { CSSProperties } from '@emotion/serialize'

type PositionStyles = {
  position: CSSProperties['position']
  top: string
  left: string
  right: string
  bottom: string
}

interface PromoTagProps {
  promotion: Promotion
  positionStyles?: PositionStyles
}

const PromoTag: React.FC<PromoTagProps> = ({
  promotion,
  positionStyles = {
    position: 'absolute',
    top: '4px',
    right: '4px',
    left: 'auto',
    bottom: 'auto'
  }
}) => {
  const { amount, discountType } = promotion

  // Temporary logic: only show promo tag for percentage or fixed discounts for now (buy one get one free coming later )
  if (
    discountType !== PromotionDiscountType.PERCENTAGE &&
    discountType !== PromotionDiscountType.FIXED
  ) {
    return null
  }

  const formatPromoText = () => {
    if (discountType === 'PERCENTAGE') {
      return `${amount}% off`
    } else {
      return `${formatMoney(amount, { stripTrailingZeros: true })} off`
    }
  }

  return (
    <PromoTagContainer
      data-testid='product-promo-tag'
      positionStyles={positionStyles}
    >
      {formatPromoText()}
    </PromoTagContainer>
  )
}

const PromoTagContainer = styled.div<
  StyledHTMLElement & {
    positionStyles: PositionStyles
  }
>(({ theme, positionStyles }) => ({
  backgroundColor: '#EF0107',
  color: theme.colors.white,
  padding: '4px 8px',
  borderRadius: '4px',
  zIndex: 1,
  minWidth: 'fit-content',
  height: 'fit-content',
  ...positionStyles
}))

export default PromoTag
